import { getPanelInterviews, interviewStats } from "@/utils/apiFunctions";
import JobDetailsModal from "@/views/PanelDashboard/modals/JobDetailsModal";
import AcceptRejectModal from "@/views/PanelDashboard/modals/AcceptRejectModal";
import ViewFeedback from "@/views/PanelDashboard/modals/ViewFeedbackModal";
import RevokeRequest from "@/views/PanelDashboard/modals/RevokeRequestModal";
import toast from "../mixin/toast";
import PanelKanbanShimmer from "@/views/PanelDashboard/PanelKanbanShimmer.vue";
import {
	formattedData,
	getRupeeImage,
} from "@/components/PanelDasboard/panelHelpers";
import { mapGetters } from "vuex";

export default {
	data() {
		return {
			// userInfo: {
			//     isPanelSuspended: true
			// },
			showSlots: false,
			intrwsLoading: false,
			showRevokeRequest: false,
			checkInterval: null,
			showViewFeedback: false,
			showJobDetailsModal: false,
			showAcceptReject: false,
			cancelInterview: false,
			warning: false,
			actionType: null,
			selectedLevel: null,
			interviewStats: null,
			sortBy: "createdAt",
			sortOrder: -1,
			searchQuery: "",
			currentLevel: 0,
			panelInformation: {
				skills: [],
				experienceLevel: "",
			},
			panelInterviews: [[], [], []],
			spinners: [],
			panelSkills: [],
			pages: [0, 0, 0],
			total: [],
			pageStart: [],
			pageEnd: [],
			showLoader: [],
			selectedInterview: {},
			pageCount: 10,
			levels: [0, 1, 2],
		};
	},
	mixins: [toast],
	components: {
		JobDetailsModal,
		AcceptRejectModal,
		PanelKanbanShimmer,
		ViewFeedback,
		RevokeRequest,
	},
	created() {
		if (this.$route.name != "JobDetails")
			this.$store.commit("candidateVUEX/setInterview", null);
	},
	computed: {
		...mapGetters("userVUEX", {
			userInfo: "getUserInfo",
		}),
	},
	methods: {
		rescheduleInterview(interview) {
			this.selectedInterview = interview;
			this.showSlots = true;
		},
		viewFeedbackData(interview) {
			this.selectedInterview = JSON.parse(JSON.stringify(interview));
			if (this.isLaptop) this.showViewFeedback = true;
			else {
				let query = {
					candidateID: interview.candidateID,
					jobID: interview.jobID,
					interviewRequestID: interview.interviewRequestID,
					frompage: this.$route.name,
				};
				if (this.$route.name == "PanelInterviews")
					query.level = this.$route.params.level;
				this.$router.push({
					name: "ViewFeedback",
					query: { ...query, ...this.$route.query },
				});
			}
		},
		hideViewFeedback() {
			this.showViewFeedback = false;
		},
		formattedData(data) {
			return formattedData(data);
		},
		getRupeeImage(level, interview) {
			return getRupeeImage(level, interview);
		},
		async getInterviewStats() {
			let payload = {
				userID: this.userInfo.userID,
			};
			const res = await interviewStats(payload);
			if (res.status == 200) {
				this.interviewStats = res.data.data;
				console.log(res);
			}
		},
		getRupeeImage(level, interview) {
			return getRupeeImage(level, interview);
		},
		async getInterviewStats() {
			let payload = {
				userID: this.userInfo.userID,
			};
			const res = await interviewStats(payload);
			if (res.status == 200) {
				this.interviewStats = res.data.data;
				console.log(res);
			}
		},
		goToJobDetails(timeRemaining, interview, index) {
			let interView = interview;
			interView.timeRemaining = timeRemaining;
			this.$store.commit("candidateVUEX/setInterview", {
				interview: interview,
				level: index,
			});
			this.$nextTick(() => {
				let route = { name: "JobDetails" };
				if (this.$route.name == "PanelInterviews") {
					route.query = {
						from: "PanelInterviews",
						level: this.$route.params.level,
					};
				}
				this.$router.push(route);
			});
		},
		goToPanelDashboard() {
			this.$router.push({ name: "PanelDashboard" });
		},
		gotToViewAll(levelValue) {
			if (!this.isLaptop) {
				this.$router.push({
					name: "PanelInterviews",
					params: {
						level: levelValue,
					},
				});
			} else {
				this.$router.push({
					name: "ViewAllInterviews",
					query: {
						level: levelValue,
					},
				});
			}
		},
		checkAndClose(type, value) {
			this.hideAcceptRejectModal();
			this.hideCancelInterview();
			if (type == "success") this.hideJobDetails();
			if (this.$route.name == "JobDetails") this.checkAndRedirect();
			else if (this.$route.name == "PanelInterviews") this.goToPanelDashboard();
			else if (value && this.$route.name != "ViewAllInterviews") {
				this.getInterviewData();
				this.getSlotData();
				this.getAllPanelData();
				const heatmapContainer = document.getElementById("heatmap2");
				if (heatmapContainer) {
					heatmapContainer.innerHTML = ""; // clear previous content
				}
				this.graphLoader = true;
				this.isLoadingGraph = true;
				setTimeout(() => {
					this.getInterviewGraph();
					this.getEarningGraph();
				}, 2000);
				this.getInterviewStats();
			}
		},
		showCancelInterview(interview, timeRemaining) {
			this.selectedInterview = interview;
			this.selectedInterview.timeRemaining = timeRemaining;
			this.cancelInterview = true;
		},
		hideCancelInterview() {
			this.cancelInterview = false;
			// this.selectedInterview =s {};
		},
		showAcceptRejectModal(type, interview) {
			if (type == "cancel") this.cancelInterview = true;
			else this.actionType = type;
			this.selectedInterview = interview;
			this.showAcceptReject = true;
		},
		hideAcceptRejectModal() {
			this.actionType = null;
			this.showAcceptReject = false;
			// this.showJobDetailsModal = false;
			// this.selectedInterview = {};
		},
		showJobDetails(timeRemaining, interview, level) {
			console.log("the interview", interview);
			this.selectedInterview = interview;
			this.selectedInterview.timeRemaining = timeRemaining;
			this.selectedLevel = level;
			this.showJobDetailsModal = true;
		},
		hideJobDetails() {
			this.showJobDetailsModal = false;
			this.selectedLevel = null;
			this.selectedInterview = {};
		},
		scrollInt(index, e) {
			const { target } = e;
			if (
				Math.ceil(target.scrollTop) >=
				target.scrollHeight - target.offsetHeight
			) {
				if (
					this.checkbetween(this.pageEnd[index], 0, this.total[index]) &&
					!this.spinners[index] &&
					!this.showLoader[index]
				) {
					this.spinners[index] = true;
					this.$forceUpdate();
					this.pages[index]++;
					this.getPanelInterviews(index);
				}
			}
		},
		checkbetween(x, min, max) {
			return x > min && x < max;
		},
		stopChecking() {
			if (this.checkInterval) {
				clearInterval(this.checkInterval);
			}
		},
		getLevelName(level) {
			let name =
				level == 0
					? "Interview Requests"
					: level == 1
					? "Upcoming Interviews"
					: "Recent Interviews";
			return name;
		},
		getNoDataText(level) {
			let text =
				level == 0
					? "No interview requests"
					: level == 1
					? "No Interviews are accepted"
					: "No interviews are taken";
			return text;
		},
		// getAmountIcon(){

		// },
		getAllPanelData() {
			this.intrwsLoading = true;
			if (this.userInfo.isPanelSuspended) this.levels = [2];
			for (let i of this.levels) {
				this.showLoader[i] = true;
				this.pages[i] = 0;
				this.total[i] = 0;
				this.pageStart[i] = 0;
				this.pageEnd[i] = 0;
				this.spinners[i] = false;
				this.getPanelInterviews(i);
			}
		},
		async getPanelInterviews(level) {
			try {
				let payload = {
					level: level,
					page: this.pages[level],
					count: this.pageCount,
					searchQuery: this.searchQuery,
					sortBy: {
						column: this.sortBy,
						order: this.sortOrder,
					},
				};
				const res = await getPanelInterviews(payload);
				if (res.status == 200) {
					if (
						this.pages[level] == 0 ||
						this.$route.name == "ViewAllInterviews"
					) {
						this.panelInterviews[level] = res.data.data.data;
					} else {
						this.panelInterviews[level] = [
							...this.panelInterviews[level],
							...res.data.data.data,
						];
					}
					this.total[level] = res.data.data.total;
					this.pageStart[level] = res.data.data.pageStart;
					this.pageEnd[level] = res.data.data.pageEnd;
					this.showLoader[level] = false;
					console.log(this.showLoader[level], level, "*************");
					this.spinners[level] = false;
					this.panelInformation = res.data.data.panelInformation;
					if (this.panelInformation.skills.length > 5) {
						this.panelSkills = this.panelInformation.skills.slice(0, 5);
					} else this.panelSkills = this.panelInformation.skills;
					this.panelSkills = Array.from(new Set(this.panelSkills));
					if (this.$route.name == "PanelDashboard") {
						this.$nextTick(() => {
							this.getScrollContainer(level); // Ensures ref updates after new data loads
						});
					} else if (this.$route.name == "ViewAllInterviews") {
						this.updateInterviewTimes();
					}
					this.$forceUpdate();
				} else {
					this.total[level] = 0;
					this.showLoader[level] = false;
				}
			} catch (error) {
				this.total[level] = 0;
				this.showLoader[level] = false;
				console.error(error);
			} finally {
				this.intrwsLoading = false;
			}
		},
	},
};
